import { Injectable } from '@angular/core';
import { URL_SERVICIOS } from 'src/app/config/config';
import { Folio } from 'src/app/models/folio';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class AsignafolioService {

  constructor(
    public http: HttpClient
  ) { }


  crearFolios() {

     const id = '5f8e45bf01c10e50ac66c817';
   //  const id = '5e6de0f6f7811c6a19c1a718';
     const url = URL_SERVICIOS + '/asignafolio1/folioprecompra/' + id;
     return this.http.get ( url )
     .map ( (resp: any) => resp.foliactual);
  }
}
